import _default from './Ref';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/addons/Ref/index.js
// module id = 29
// module chunks = 0